import React from 'react';
import '../less/main.less';

export default function template() {
    const { img, topImg, text, textMob, title, toggleModal, page, isMobile, btnText, link, subTitle, logo, dates, children, offerMode, complDates, formAnalytics, bg, titleTag, award } = this.props,
      TitleTag = titleTag || 'h1',

      btn = toggleModal || btnText ?
        (
          <button className={`btn-success ${formAnalytics ? 'form-open' : ''}`} id={`banner-button ${page} `} onClick={toggleModal ? toggleModal : () => window.open(link.link, link.target)}>
            {this.l10n(btnText ? btnText : 'SEND_APPLICATION')}
          </button>
        )
        : '',
      topImgBlock = topImg ? (
        <img className="top-image" src={topImg} alt='top_image'/>
      ) : '',
      subTitleBlock = subTitle ? (
        <div className="banner-sub-title" dangerouslySetInnerHTML={{ __html: this.l10n(subTitle) }}/>
      ) : '',
      datesBlock = dates
        ? complDates
          ? dates
          : (<div className="banner-dates" dangerouslySetInnerHTML={{ __html: this.l10n(dates) }} />)
        : "",
      rightSide = img ?
        (<div className="banner-right-side">
          <img className="banner-right-side-img" src={img} alt=" " />
        </div>)
        :
        '',
      awardBlock = award ?
        (<a className="award-block" href={award.link} rel="noopener noreferrer" target='_blank'>
          <img src={award.img} alt={this.l10n(award.text)} className="award-block-image"/>
          <div className="award-block-content">
            <div className="award-block-title">{this.l10n(award.title)}</div>
            <div className="award-block-text">{this.l10n(award.text)}</div>
          </div>
        </a>) : '';

    return (
      <section className={`banner-module ${page}`}>
        {
          offerMode ?
            <a className="banner-module-content" href={offerMode ? link : null } style={{
              background: `url(${bg}) center / contain no-repeat`}} target={'_blank'}>
              <div className="banner-left-side">
                {topImgBlock}
                {subTitleBlock}
                <TitleTag className="banner-title" dangerouslySetInnerHTML={{ __html: this.l10n(title) }}/>
                <div className="banner-message" dangerouslySetInnerHTML={{__html: isMobile ? this.l10n(textMob) : this.l10n(text)}}>
                </div>
                {logo}
                { children ? children : btn}
                {datesBlock}
                {awardBlock}
              </div>
              {rightSide}
            </a>
            :
            <div className="banner-module-content" onClick={offerMode ? toggleModal : null }>
              <div className="banner-left-side">
                {topImgBlock}
                {subTitleBlock}
                <TitleTag className="banner-title" dangerouslySetInnerHTML={{ __html: this.l10n(title) }}/>
                <div className="banner-message" dangerouslySetInnerHTML={{__html: isMobile ? this.l10n(textMob) : this.l10n(text)}}>
                </div>
                {logo}
                { children ? children : btn}
                {datesBlock}
                {awardBlock}
              </div>
              {rightSide}
            </div>
        }
      </section>
    );
}
